module.exports = __webpack_public_path__ + "img/partlycloudy.fc7a2bf1.png";